module.exports = __webpack_public_path__ + "img/réunion.8b296b78.svg";